import { jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { MuiClassCollection } from "../../foundations/mui-class-collection.es.js";
import { theme } from "../../foundations/theme.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/react/jsx-runtime.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.es.es.js";
import "react";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.es.es.js";
import { styled } from "@mui/material";
import { ArrowDownSmallOutlined as l } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/arrow-down-small-outlined.es.es.js";
import { ArrowUpSmallOutlined as n } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/arrow-up-small-outlined.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/turn-icons.es.es.js";
import { DataGrid } from "../../../node_modules/@mui/x-data-grid/DataGrid/DataGrid.es.js";
import { gridClasses } from "../../../node_modules/@mui/x-data-grid/constants/gridClasses.es.js";
import { Typography } from "../typography/typography.es.js";
const TABLE_ODD_ROW_BACKGROUND_COLOR = "#171F3614";
const TABLE_ODD_ROW_HOVER_BACKGROUND_COLOR = "#171F3629";
const TABLE_CELL_MIN_WIDTH_PX = 140;
const TABLE_SMALL_CELL_MIN_HEIGHT_PX = 36;
const TABLE_SMALL_CELL_MAX_HEIGHT_PX = 48;
const TABLE_MEDIUM_CELL_MIN_HEIGHT_PX = 64;
const TABLE_MEDIUM_CELL_MAX_HEIGHT_PX = 96;
const TABLE_SMALL_CELL_PADDING = `${theme.spacing(0)} ${theme.spacing(4)}`;
const TABLE_MEDIUM_CELL_PADDING = `${theme.spacing(2)} ${theme.spacing(4)}`;
function Table({
  columns,
  size,
  ...rest
}) {
  function getRowClassName(params) {
    return params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd";
  }
  return /* @__PURE__ */ jsx(StyledTable, { ...rest, getRowHeight: function getRowHeight() {
    return "auto";
  }, columns: columns.map(function toColumnHeader(column) {
    return {
      ...column,
      minWidth: TABLE_CELL_MIN_WIDTH_PX,
      renderHeader: ({
        colDef: {
          headerName
        }
      }) => /* @__PURE__ */ jsx(TableHeader, { children: headerName })
    };
  }), slots: {
    columnSortedDescendingIcon: n,
    columnSortedAscendingIcon: l
  }, getRowClassName, disableColumnMenu: true, disableColumnFilter: true, hideFooter: true, sx: {
    ".MuiDataGrid-columnHeader, .MuiDataGrid-cell": {
      padding: size === "small" ? TABLE_SMALL_CELL_PADDING : TABLE_MEDIUM_CELL_PADDING
    },
    "& .MuiDataGrid-cell, & .MuiDataGrid-columnHeader": {
      minHeight: size === "small" ? TABLE_SMALL_CELL_MIN_HEIGHT_PX : TABLE_MEDIUM_CELL_MIN_HEIGHT_PX,
      maxHeight: size === "small" ? TABLE_SMALL_CELL_MAX_HEIGHT_PX : TABLE_MEDIUM_CELL_MAX_HEIGHT_PX
    },
    ".MuiDataGrid-columnHeaderCheckbox": {
      padding: theme.spacing(0)
    }
  } });
}
function TableHeader({
  children
}) {
  return /* @__PURE__ */ jsx(Typography, { variant: "subtitle1", fontWeight: "bold", children });
}
const StyledTable = styled(DataGrid)(({
  theme: theme2
}) => ({
  "&.MuiDataGrid-root": {
    overflow: "hidden",
    borderColor: theme2.palette.border.main
  },
  ".MuiDataGrid-row--lastVisible .MuiDataGrid-cell": {
    borderBottom: "none"
  },
  "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within, &.MuiDataGrid-root .MuiDataGrid-columnHeader:focus-within": {
    outline: "none"
  },
  "&.MuiDataGrid-root .MuiDataGrid-columnSeparator": {
    display: "none"
  },
  [`& .${gridClasses.row}.odd`]: {
    backgroundColor: TABLE_ODD_ROW_BACKGROUND_COLOR,
    [`&:hover, &.${MuiClassCollection.hovered}`]: {
      backgroundColor: TABLE_ODD_ROW_HOVER_BACKGROUND_COLOR
    },
    [`&.${MuiClassCollection.selected}`]: {
      backgroundColor: theme2.palette.primary.light
    }
  },
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: theme2.palette.common.white,
    [`&:hover, &.${MuiClassCollection.hovered}`]: {
      backgroundColor: theme2.palette.action.hover
    },
    [`&.${MuiClassCollection.selected}`]: {
      backgroundColor: theme2.palette.primary.light
    }
  }
}));
export {
  StyledTable,
  Table
};
//# sourceMappingURL=table.es.js.map
